import React from 'react';

export const METODOS_PAGO_LISTA = [
    {
        id: 'yape',
        nombre: 'Yape',
        tipo: 'Billetera Digital',
        color: '#742284',
        bg: '#fbf0ff',
        border: '#d997ea',
        iconoTipo: 'svg_yape'
    },
    {
        id: 'plin',
        nombre: 'Plin',
        tipo: 'Billetera Digital',
        color: '#00a8e8',
        bg: '#edf9ff',
        border: '#90daf8',
        iconoTipo: 'svg_plin'
    },
    {
        id: 'efectivo',
        nombre: 'Efectivo',
        tipo: 'Efectivo',
        color: '#15803d',
        bg: '#f0fdf4',
        border: '#86efac',
        iconoTipo: 'svg_efectivo'
    },
    {
        id: 'visa',
        nombre: 'Visa',
        tipo: 'Tarjeta Débito/Crédito',
        color: '#1a1f71',
        bg: '#eff6ff',
        border: '#93c5fd',
        iconoTipo: 'svg_visa'
    },
    {
        id: 'mastercard',
        nombre: 'Mastercard',
        tipo: 'Tarjeta Débito/Crédito',
        color: '#eb001b',
        bg: '#fff1f2',
        border: '#fca5a5',
        iconoTipo: 'svg_mastercard'
    },
    {
        id: 'amex',
        nombre: 'American Express',
        tipo: 'Tarjeta',
        color: '#016fd0',
        bg: '#f0f9ff',
        border: '#7dd3fc',
        iconoTipo: 'svg_amex'
    },
    {
        id: 'bcp',
        nombre: 'BCP',
        tipo: 'Transferencia Bancaria',
        color: '#ff7800',
        bg: '#fff7ed',
        border: '#fed7aa',
        iconoTipo: 'svg_bcp'
    },
    {
        id: 'bbva',
        nombre: 'BBVA',
        tipo: 'Transferencia Bancaria',
        color: '#004481',
        bg: '#eff6ff',
        border: '#bfdbfe',
        iconoTipo: 'svg_bbva'
    },
    {
        id: 'interbank',
        nombre: 'Interbank',
        tipo: 'Transferencia Bancaria',
        color: '#009939',
        bg: '#f0fdf4',
        border: '#bbf7d0',
        iconoTipo: 'svg_interbank'
    },
    {
        id: 'scotiabank',
        nombre: 'Scotiabank',
        tipo: 'Transferencia Bancaria',
        color: '#ec111a',
        bg: '#fef2f2',
        border: '#fecaca',
        iconoTipo: 'svg_scotiabank'
    },
    {
        id: 'banconacion',
        nombre: 'Banco de la Nación',
        tipo: 'Transferencia Bancaria',
        color: '#c00000',
        bg: '#fef2f2',
        border: '#fca5a5',
        iconoTipo: 'svg_banconacion'
    },
    {
        id: 'pagoefectivo',
        nombre: 'PagoEfectivo',
        tipo: 'Código de Pago',
        color: '#ffc600',
        bg: '#fffbeb',
        border: '#fde68a',
        iconoTipo: 'svg_pagoefectivo'
    },
    {
        id: 'pos',
        nombre: 'POS / Todas las Tarjetas',
        tipo: 'Cobro con Tarjeta',
        color: '#334155',
        bg: '#f8fafc',
        border: '#cbd5e1',
        iconoTipo: 'svg_pos'
    }
];

export function renderIconoMetodo(tipo) {
    switch (tipo) {
        case 'svg_yape':
            return (
                <svg viewBox="0 0 48 48" width="28" height="28" fill="none">
                    <rect width="48" height="48" rx="12" fill="#742284"/>
                    <path d="M14 16h6l5 10 5-10h6l-8 15v7h-6v-7l-8-15z" fill="#00d0b6"/>
                    <circle cx="33" cy="18" r="3" fill="#ffc600"/>
                </svg>
            );
        case 'svg_plin':
            return (
                <svg viewBox="0 0 48 48" width="28" height="28" fill="none">
                    <rect width="48" height="48" rx="12" fill="#00a8e8"/>
                    <path d="M15 14h8c5 0 9 3 9 7s-4 7-9 7h-2v6h-6V14zm6 9h2c2 0 3-1 3-2s-1-2-3-2h-2v4z" fill="#ffffff"/>
                    <circle cx="35" cy="30" r="3.5" fill="#00d0b6"/>
                </svg>
            );
        case 'svg_efectivo':
            return (
                <svg viewBox="0 0 48 48" width="28" height="28" fill="none">
                    <rect width="48" height="48" rx="12" fill="#15803d"/>
                    <rect x="10" y="15" width="28" height="18" rx="3" fill="#86efac" stroke="#ffffff" strokeWidth="2"/>
                    <circle cx="24" cy="24" r="4.5" fill="#15803d"/>
                    <circle cx="15" cy="24" r="1.5" fill="#15803d"/>
                    <circle cx="33" cy="24" r="1.5" fill="#15803d"/>
                </svg>
            );
        case 'svg_visa':
            return (
                <svg viewBox="0 0 48 48" width="28" height="28" fill="none">
                    <rect width="48" height="48" rx="12" fill="#ffffff" stroke="#e2e8f0" strokeWidth="1.5"/>
                    <path d="M19.5 30l2.5-12h3.5l-2.5 12h-3.5zm12.8-11.7c-.7-.3-1.8-.5-3.1-.5-3.4 0-5.8 1.7-5.8 4.2 0 1.8 1.7 2.8 3 3.4 1.3.6 1.8 1 1.8 1.6 0 .9-1.1 1.3-2.2 1.3-1.5 0-2.3-.2-3.5-.7l-.5-.2-.5 3c.9.4 2.5.7 4.2.7 3.6 0 6-1.7 6-4.3 0-1.4-.9-2.5-3-3.4-1.2-.6-2-1-2-1.6 0-.6.7-1.1 2.1-1.1 1.2 0 2.1.2 2.7.5l.3.2.5-2.6zm8.2-.3h-2.8c-.9 0-1.5.2-1.9 1.1l-5.3 11h3.8l.8-2h4.6l.4 2h3.3l-2.9-12.1zm-4.7 7.5l2-5.4 1.1 5.4h-3.1zm-21.3-7.5l-3.5 8.8-.4-1.8c-.6-2.1-2.5-4.4-4.6-5.5l3 10.5h3.8l5.7-12h-4z" fill="#1a1f71"/>
                </svg>
            );
        case 'svg_mastercard':
            return (
                <svg viewBox="0 0 48 48" width="28" height="28" fill="none">
                    <rect width="48" height="48" rx="12" fill="#222222"/>
                    <circle cx="19" cy="24" r="9" fill="#eb001b"/>
                    <circle cx="29" cy="24" r="9" fill="#f79e1b"/>
                    <path d="M24 17.5a8.9 8.9 0 000 13 8.9 8.9 0 000-13z" fill="#ff5f00"/>
                </svg>
            );
        case 'svg_bcp':
            return (
                <svg viewBox="0 0 48 48" width="28" height="28" fill="none">
                    <rect width="48" height="48" rx="12" fill="#002a8f"/>
                    <path d="M12 16h11c4 0 7 2 7 5s-2 4-5 4c3.5 0 6 2 6 5.5s-3 5.5-8 5.5H12V16z" fill="#ff7800"/>
                    <circle cx="34" cy="24" r="3.5" fill="#ffffff"/>
                </svg>
            );
        case 'svg_bbva':
            return (
                <svg viewBox="0 0 48 48" width="28" height="28" fill="none">
                    <rect width="48" height="48" rx="12" fill="#004481"/>
                    <text x="24" y="29" fill="#ffffff" fontSize="11" fontWeight="bold" textAnchor="middle" fontFamily="sans-serif">BBVA</text>
                </svg>
            );
        case 'svg_interbank':
            return (
                <svg viewBox="0 0 48 48" width="28" height="28" fill="none">
                    <rect width="48" height="48" rx="12" fill="#009939"/>
                    <circle cx="24" cy="24" r="11" fill="#ffffff"/>
                    <path d="M20 18h8v3h-5v3h4v3h-4v4h-3V18z" fill="#009939"/>
                </svg>
            );
        case 'svg_scotiabank':
            return (
                <svg viewBox="0 0 48 48" width="28" height="28" fill="none">
                    <rect width="48" height="48" rx="12" fill="#ec111a"/>
                    <path d="M24 14c-5 0-9 3-9 7 0 5 6 6 6 8 0 1-1 2-3 2-2 0-4-1-5-2l-2 3c2 2 4 3 7 3 5 0 9-3 9-7 0-5-6-6-6-8 0-1 1-2 3-2 2 0 4 1 5 2l2-3c-2-2-4-3-7-3z" fill="#ffffff"/>
                </svg>
            );
        case 'svg_banconacion':
            return (
                <svg viewBox="0 0 48 48" width="28" height="28" fill="none">
                    <rect width="48" height="48" rx="12" fill="#c00000"/>
                    <text x="24" y="27" fill="#ffffff" fontSize="11" fontWeight="bold" textAnchor="middle" fontFamily="sans-serif">BN</text>
                    <text x="24" y="36" fill="#ffffff" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">PERÚ</text>
                </svg>
            );
        case 'svg_pagoefectivo':
            return (
                <svg viewBox="0 0 48 48" width="28" height="28" fill="none">
                    <rect width="48" height="48" rx="12" fill="#ffc600"/>
                    <rect x="13" y="16" width="22" height="16" rx="2" fill="#222222"/>
                    <circle cx="24" cy="24" r="3.5" fill="#ffc600"/>
                </svg>
            );
        case 'svg_amex':
            return (
                <svg viewBox="0 0 48 48" width="28" height="28" fill="none">
                    <rect width="48" height="48" rx="12" fill="#016fd0"/>
                    <text x="24" y="28" fill="#ffffff" fontSize="9" fontWeight="bold" textAnchor="middle" fontFamily="sans-serif">AMEX</text>
                </svg>
            );
        case 'svg_pos':
        default:
            return (
                <svg viewBox="0 0 48 48" width="28" height="28" fill="none">
                    <rect width="48" height="48" rx="12" fill="#334155"/>
                    <rect x="13" y="12" width="22" height="24" rx="3" fill="#ffffff"/>
                    <rect x="16" y="15" width="16" height="7" rx="1" fill="#0f172a"/>
                    <circle cx="18" cy="26" r="1.5" fill="#334155"/>
                    <circle cx="24" cy="26" r="1.5" fill="#334155"/>
                    <circle cx="30" cy="26" r="1.5" fill="#334155"/>
                    <circle cx="18" cy="31" r="1.5" fill="#334155"/>
                    <circle cx="24" cy="31" r="1.5" fill="#334155"/>
                    <circle cx="30" cy="31" r="1.5" fill="#334155"/>
                </svg>
            );
    }
}

/**
 * Parsea el string de metodosPago guardado en BD a un array de IDs seleccionados
 */
export function parsearMetodosPago(raw) {
    if (!raw) return [];

    if (Array.isArray(raw)) return raw;

    try {
        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) return parsed;
    } catch (e) {
        // No es JSON, intentar separar por coma o palabras clave
    }

    const texto = String(raw).toLowerCase();
    const ids = [];

    METODOS_PAGO_LISTA.forEach(m => {
        if (texto.includes(m.id) || texto.includes(m.nombre.toLowerCase())) {
            ids.push(m.id);
        }
    });

    return ids;
}
